import { ReactNode, useRef } from 'react';
import { Dialog, Modal as AriaModal, ModalOverlay } from 'react-aria-components';
import { Box, Heading, IconButton } from '@alto-avios/alto-ui';
import { clsx } from 'clsx';

import styles from './Modal.module.css';

interface ModalShellProps {
  heading: string;
  isOpen: boolean;
  onClose: () => void;
  ariaLabel: string;
  closeButtonAriaLabel: string;
  size?: 'small' | 'medium' | 'large';
  children: ReactNode;
}

export const ModalShell = ({ heading, isOpen, onClose, ariaLabel, closeButtonAriaLabel, size = 'medium', children }: ModalShellProps) => {
  const overlayRef = useRef<HTMLDivElement | null>(null);

  return (
    <ModalOverlay
      className={styles.overlay}
      isOpen={isOpen}
      isDismissable
      onOpenChange={(open) => !open && onClose()}
      shouldCloseOnInteractOutside={(element) => overlayRef.current === element}
      ref={overlayRef}
    >
      <AriaModal className={clsx(styles.modal, styles[size])}>
        <Dialog aria-label={ariaLabel} className={styles.dialog}>
          <Box alignItems="center" justifyContent="spaceBetween">
            <Heading size="xxs" foregroundColor="default">
              {heading}
            </Heading>
            <IconButton
              aria-label={closeButtonAriaLabel}
              emphasis="quaternary"
              iconProps={{ iconName: 'times' }}
              onClick={onClose}
              styleVariant="neutral"
              size="sm"
            />
          </Box>
          <div className={styles.body}>{children}</div>
        </Dialog>
      </AriaModal>
    </ModalOverlay>
  );
};
